import { Editor } from '@tiptap/core';

import { IconName } from 'components/elements/types';

import i18n from './i18n';

type ListOption = {
  name: string;
  icon: IconName;
  message: typeof i18n[keyof typeof i18n];
  isActive: (editor: Editor) => boolean;
  command: (editor: Editor) => void;
};

export const LIST_OPTIONS: ListOption[] = [
  {
    name: 'bulletList',
    icon: 'ListDashes',
    message: i18n.toolBulletList,
    isActive: (editor) => editor.isActive('bulletList'),
    command: (editor) => editor.chain().focus().toggleBulletList().run(),
  },
  {
    name: 'orderedList',
    icon: 'ListNumbers',
    message: i18n.toolOrderedList,
    isActive: (editor) => editor.isActive('orderedList'),
    command: (editor) => editor.chain().focus().toggleOrderedList().run(),
  },
];

export const activeListOption = (editor: Editor) =>
  LIST_OPTIONS.find((option) => option.isActive(editor));
